"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRequiredIf = _interopRequireDefault(require("react-required-if"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../CTAs/Button"));

var _ = require(".");

var _excluded = ["text", "ariaLabel", "dataTestId"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DropdownTrigger = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var text = _ref.text,
      ariaLabel = _ref.ariaLabel,
      dataTestId = _ref.dataTestId,
      additionalProps = _objectWithoutProperties(_ref, _excluded);

  var _useContext = (0, _react.useContext)(_.ToggleContext),
      toggleShow = _useContext.toggleShow,
      setToggleShow = _useContext.setToggleShow;

  return /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
    ariaLabel: ariaLabel,
    ariaExpanded: toggleShow ? 'true' : 'false',
    classes: "dropdown-menu__trigger ".concat(toggleShow ? 'dropdown-menu__trigger--is-open' : ''),
    clickMethod: function clickMethod() {
      return setToggleShow(!toggleShow);
    },
    dataTestId: dataTestId,
    icon: "IconChevronDown",
    iconPosition: "right",
    size: "large",
    text: text,
    variant: "text-alternate",
    ref: ref
  }, additionalProps));
});
DropdownTrigger.displayName = 'DropdownTrigger';
DropdownTrigger.propTypes = {
  /**
   Required. Trigger button aria-label.
   */
  ariaLabel: (0, _reactRequiredIf.default)(_propTypes.default.string, function (props) {
    return !props.text;
  }),

  /**
   Optional, but recommended. Gives a unique identifier to the element which is useful for testing scenarios. Defaults to null.
   */
  dataTestId: _propTypes.default.string,

  /**
   Required. Trigger button text.
   */
  text: _propTypes.default.string.isRequired
};
DropdownTrigger.defaultProps = {
  ariaLabel: '',
  dataTestId: null
};
var _default = DropdownTrigger;
exports.default = _default;